import type { ChatPanelBodyProps } from '@halo/ui-chat-react';
import { ChatPanelBody } from '@halo/ui-chat-react';
import { useShallowEnhance } from '@halo/zustand-enhance';
import { SessionsStatus, useAppStore } from '@/store/client';
import chatPanelBodyImg from '@/assets/images/common/images/chatPanelBodyImg.jpg';

const background = `url(${chatPanelBodyImg})`;

export interface SessionBodyProps extends ChatPanelBodyProps {}

export function SessionBody(props: SessionBodyProps) {
  const { user, sessionsStatus } = useAppStore(useShallowEnhance(['user', 'sessionsStatus']));
  const isLoading = useMemo(
    () => !(user?.username && sessionsStatus > SessionsStatus.LOADING),
    [sessionsStatus, user?.username]
  );

  return <ChatPanelBody loading={isLoading} background={background} {...props}></ChatPanelBody>;
}
